/**
 * Menu Hover Image Web Component
 * Updates the megamenu image when hovering over menu links
 */
class MenuHoverImage extends HTMLElement {
  private imageSrc: string | null;
  private imageAlt: string | null;
  private targetImage: HTMLImageElement | null = null;
  private preloadedImage: HTMLImageElement | null = null;
  private menuColumns: HTMLElement | null = null;

  constructor() {
    super();
    this.imageSrc = this.dataset.imageSrc || null;
    this.imageAlt = this.dataset.imageAlt || '';
  }

  connectedCallback() {
    // Find the target image container in the megamenu
    const megamenu = this.closest('.main-menu__megamenu');
    
    if (megamenu) {
      this.targetImage = megamenu.querySelector('.main-menu__megamenu-tile-image img');
    }

    // Preload the image to prevent flickering
    if (this.imageSrc) {
      this.preloadedImage = new Image();
      this.preloadedImage.src = this.imageSrc;
    }

    // Add hover event listener to individual items
    this.addEventListener('mouseenter', this.handleMouseEnter);
    
    // Add mouseleave to the entire menu columns area instead of individual items
    this.menuColumns = this.closest('.main-menu__megamenu-columns');
    if (this.menuColumns && !(this.menuColumns as any).__menuLeaveListener) {
      // Mark that we've added the listener to prevent duplicates
      (this.menuColumns as any).__menuLeaveListener = true;
      this.menuColumns.addEventListener('mouseleave', this.handleMenuLeave);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.handleMouseEnter);
    // Don't remove the menuColumns listener as it's shared
  }

  private handleMouseEnter = () => {
    // Only proceed if we have a valid image source and target
    if (!this.imageSrc || this.imageSrc === '' || !this.targetImage) {
      return;
    }

    // Store the original image if not already stored
    if (!this.targetImage.dataset.originalSrc) {
      this.targetImage.dataset.originalSrc = this.targetImage.src;
      this.targetImage.dataset.originalAlt = this.targetImage.alt || '';
      this.targetImage.dataset.originalSrcset = this.targetImage.srcset || '';
    }

    // Instant swap - no transition flicker
    // The image is already preloaded, so this should be instant
    this.targetImage.src = this.imageSrc;
    this.targetImage.srcset = this.imageSrc; // Update srcset to override responsive images
    this.targetImage.alt = this.imageAlt || '';
  };

  private handleMenuLeave = () => {
    // Revert to original image when mouse leaves the entire menu area
    if (!this.targetImage || !this.targetImage.dataset.originalSrc) {
      return;
    }

    // Instant revert - no transition
    this.targetImage.src = this.targetImage.dataset.originalSrc;
    this.targetImage.srcset = this.targetImage.dataset.originalSrcset || '';
    this.targetImage.alt = this.targetImage.dataset.originalAlt || '';
  };
}

export default MenuHoverImage;

